module.exports = __webpack_public_path__ + "img/screen-1-step-1.77a534a3.png";